import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-no-connection-modal',
    standalone: true,
    imports: [MatIconModule, MatButtonModule],
    templateUrl: './no-connection-modal.component.html',
    styleUrl: './no-connection-modal.component.scss',
    host: { class: 'w-full h-full min-h-0 flex flex-col' },
    encapsulation: ViewEncapsulation.None,
})
export class NoConnectionModalComponent {
    constructor(
        public dialogRef: MatDialogRef<NoConnectionModalComponent>
    ) { }
}
